import React, { useState, useEffect, useRef } from 'react';
import { Spin, Empty, Button, Tag } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import axiosInst from '../../utils/axios';
import moment from 'moment';

export default function QoCOnlineUsers() {
    const [users,   setUsers]   = useState([]);
    const [loading, setLoading] = useState(false);
    const timerRef = useRef();

    const load = async () => {
        setLoading(true);
        try {
            const res = await axiosInst.get('online-users');
            setUsers(res.data?.data || []);
        } catch(e) { console.error(e); }
        finally { setLoading(false); }
    };

    useEffect(() => {
        load();
        timerRef.current = setInterval(load, 30000);
        return () => clearInterval(timerRef.current);
    }, []);

    const onlineUsers  = users.filter(u => parseInt(u.is_online) === 1);
    const offlineUsers = users.filter(u => parseInt(u.is_online) !== 1);

    const UserRow = ({ u, online }) => (
        <div style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 16px', borderBottom:'1px solid #f0f0f0', background:'#fff' }}>
            <div style={{ width:10, height:10, borderRadius:'50%', background:online?'#52c41a':'#d9d9d9', flexShrink:0 }}/>
            <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:13, fontWeight:600 }}>{u.name || u.username}</div>
                <div style={{ fontSize:11, color:'#888' }}>{u.role}{u.facility ? ' · ' + u.facility : ''}</div>
            </div>
            <div style={{ fontSize:11, color: online ? '#52c41a' : '#aaa', flexShrink:0 }}>
                {online ? <Tag color="success">Online Now</Tag> : u.last_login ? moment(u.last_login).fromNow() : 'Never'}
            </div>
        </div>
    );

    return (
        <div className="page-content">
            <div style={{ padding:'16px 24px', borderBottom:'1px solid #f0f0f0', background:'#fff', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                    <div style={{ fontSize:18, fontWeight:800, color:'#1f3864' }}>👥 Platform Users</div>
                    <div style={{ fontSize:12, color:'#888', marginTop:2 }}>
                        <span style={{ color:'#52c41a', fontWeight:700 }}>{onlineUsers.length} online</span>
                        {' · '}
                        {users.length} total · refreshes every 30s
                    </div>
                </div>
                <Button icon={<ReloadOutlined/>} onClick={load} loading={loading}>Refresh</Button>
            </div>

            <div style={{ padding:'16px 24px' }}>
                <Spin spinning={loading && users.length === 0}>
                    {onlineUsers.length > 0 && (
                        <div style={{ marginBottom:24 }}>
                            <div style={{ fontSize:11, fontWeight:800, color:'#52c41a', marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>
                                🟢 Online Now ({onlineUsers.length})
                            </div>
                            <div style={{ border:'1px solid #f0f0f0', borderRadius:8, overflow:'hidden' }}>
                                {onlineUsers.map(u => <UserRow key={u.id} u={u} online/>)}
                            </div>
                        </div>
                    )}

                    {offlineUsers.length > 0 && (
                        <div>
                            <div style={{ fontSize:11, fontWeight:800, color:'#aaa', marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>
                                ⚫ Recently Active ({offlineUsers.length})
                            </div>
                            <div style={{ border:'1px solid #f0f0f0', borderRadius:8, overflow:'hidden' }}>
                                {offlineUsers.map(u => <UserRow key={u.id} u={u} online={false}/>)}
                            </div>
                        </div>
                    )}

                    {!loading && users.length === 0 && (
                        <Empty description="No users found" style={{ padding:60 }}/>
                    )}
                </Spin>
            </div>
        </div>
    );
}
